import { defineComponent, onMounted, onUnmounted } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import TitleBlockCode from '@/presentation/components/shared/title-block/title-block.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new TitleBlockCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			latestSavedName: code.latestSavedName,
			isPrimaryDataLoading: code.isPrimaryDataLoading,
			isCampaignReadinessInfoLoading: code.isCampaignReadinessInfoLoading,
			isCampaignValid: code.isCampaignValid,
			isCampaignInvalid: code.isCampaignInvalid,
			campaignIssuesAsSentences: code.campaignIssuesAsSentences
		};
	}
});
